import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-teal-50 to-cyan-50">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        
        {/* Header */}
        <div className="mb-8">
          <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-4">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Zurück zur Startseite
          </Link>
          <h1 className="text-4xl font-bold text-gray-900 mb-2">Datenschutzerklärung</h1>
          <p className="text-gray-600">NEUROBOND by MYSYMP AG</p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-lg shadow-lg p-8 prose max-w-none">
          
          <h2>1. Verantwortlicher</h2>
          <p>
            Verantwortlich für die Datenverarbeitung auf dieser Website ist:<br />
            <strong>MYSYMP AG</strong><br />
            CH-6207 Nottwil<br />
            Schweiz<br />
            E-Mail: info@interlingua.app
          </p>

          <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
          <p>
            Wir erheben und verarbeiten personenbezogene Daten nur, soweit dies zur Bereitstellung 
            unserer Dienstleistungen erforderlich ist oder Sie ausdrücklich eingewilligt haben.
          </p>

          <h3>2.1 Registrierung und Nutzung der INTERLINGUA.APP-Plattform</h3>
          <p>Bei der Registrierung erheben wir folgende Daten:</p>
          <ul>
            <li>Name</li>
            <li>E-Mail-Adresse</li>
            <li>Muttersprache</li>
            <li>Gewünschte Lernsprachen</li>
            <li>Sprachniveau</li>
            <li>Optional: Profilbild und KI-Lehrer Avatar</li>
          </ul>

          <h3>2.2 Lernfortschritt und Konversationen</h3>
          <p>Zur Verbesserung des Lernerlebnisses speichern wir:</p>
          <ul>
            <li>Konversationsverlauf mit der KI</li>
            <li>Lernfortschritt und Statistiken</li>
            <li>Aussprache-Aufnahmen (zur Analyse und Verbesserung)</li>
          </ul>

          <h2>3. Zweck der Datenverarbeitung</h2>
          <p>Die Verarbeitung Ihrer Daten erfolgt zu folgenden Zwecken:</p>
          <ul>
            <li>Bereitstellung der Sprachlern-Dienstleistungen</li>
            <li>Personalisierung des Lernerlebnisses</li>
            <li>Verbesserung der KI-Algorithmen</li>
            <li>Kommunikation bezüglich der Dienstleistung</li>
            <li>Abwicklung von Zahlungen (bei Premium-Funktionen)</li>
          </ul>

          <h2>4. Rechtsgrundlage der Verarbeitung</h2>
          <p>
            Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage der 
            EU-Datenschutz-Grundverordnung (DSGVO):
          </p>
          <ul>
            <li>Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung)</li>
            <li>Art. 6 Abs. 1 lit. f DSGVO (berechtigte Interessen)</li>
            <li>Art. 6 Abs. 1 lit. a DSGVO (Einwilligung bei freiwilligen Angaben)</li>
          </ul>

          <h2>5. Datenweitergabe</h2>
          <p>
            Ihre Daten werden nicht an Dritte weitergegeben, es sei denn:
          </p>
          <ul>
            <li>Sie haben ausdrücklich eingewilligt</li>
            <li>Die Weitergabe ist zur Vertragserfüllung erforderlich</li>
            <li>Wir sind gesetzlich zur Weitergabe verpflichtet</li>
          </ul>

          <h3>5.1 Auftragsverarbeiter</h3>
          <p>Wir nutzen folgende Dienstleister zur Bereitstellung unserer Services:</p>
          <ul>
            <li>Cloud-Hosting-Provider für die Infrastruktur</li>
            <li>KI-Dienstleister für Sprachverarbeitung</li>
            <li>Analytics-Dienste (anonymisiert)</li>
          </ul>

          <h2>6. Speicherdauer</h2>
          <p>
            Wir speichern Ihre Daten nur solange, wie es für die genannten Zwecke erforderlich ist:
          </p>
          <ul>
            <li>Kontodaten: Bis zur Löschung des Kontos</li>
            <li>Konversationsdaten: 2 Jahre nach letzter Aktivität</li>
            <li>Aussprache-Aufnahmen: 1 Jahr zur Verbesserung der KI</li>
          </ul>

          <h2>7. Ihre Rechte</h2>
          <p>Sie haben folgende Rechte bezüglich Ihrer personenbezogenen Daten:</p>
          <ul>
            <li><strong>Auskunftsrecht:</strong> Sie können Auskunft über die von uns gespeicherten Daten verlangen</li>
            <li><strong>Berichtigungsrecht:</strong> Sie können die Berichtigung unrichtiger Daten verlangen</li>
            <li><strong>Löschungsrecht:</strong> Sie können die Löschung Ihrer Daten verlangen</li>
            <li><strong>Einschränkungsrecht:</strong> Sie können die Einschränkung der Verarbeitung verlangen</li>
            <li><strong>Widerspruchsrecht:</strong> Sie können der Verarbeitung widersprechen</li>
            <li><strong>Datenübertragbarkeit:</strong> Sie können die Übertragung Ihrer Daten verlangen</li>
          </ul>

          <h2>8. Cookies und Tracking</h2>
          <p>
            Unsere Website verwendet Cookies zur Verbesserung der Benutzererfahrung. 
            Weitere Informationen finden Sie in unserer Cookie-Richtlinie.
          </p>

          <h2>9. Datensicherheit</h2>
          <p>
            Wir setzen technische und organisatorische Maßnahmen ein, um Ihre Daten vor 
            unbefugtem Zugriff, Verlust oder Missbrauch zu schützen:
          </p>
          <ul>
            <li>SSL/TLS-Verschlüsselung</li>
            <li>Sichere Datenzentren in der EU</li>
            <li>Regelmäßige Sicherheitsaudits</li>
            <li>Zugriffsbeschränkungen</li>
          </ul>

          <h2>10. Änderungen der Datenschutzerklärung</h2>
          <p>
            Wir behalten uns vor, diese Datenschutzerklärung bei Bedarf zu aktualisieren. 
            Die aktuelle Version finden Sie stets auf unserer Website.
          </p>

          <h2>11. Kontakt</h2>
          <p>
            Bei Fragen zum Datenschutz können Sie uns kontaktieren:<br />
            E-Mail: info@interlingua.app<br />
            Adresse: MYSYMP AG, CH-6207 Nottwil, Schweiz
          </p>

          <div className="border-t pt-6 mt-8 text-sm text-gray-500">
            <p>Stand: {new Date().toLocaleDateString('de-DE')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;